import { safeGetPortalsLoginVerifyEarlyRequest } from './portalsLoginVerify';
export async function getPortalsLocaleInfo(config) {
  const searchParams = new URLSearchParams(window.location.search);
  const localeOverride = searchParams.get('localeOverride');
  if (localeOverride) {
    return {
      langEnabled: true,
      locale: localeOverride
    };
  }
  const loginData = await safeGetPortalsLoginVerifyEarlyRequest({
    objectId: config.objectId
  });
  if ((loginData === null || loginData === void 0 ? void 0 : loginData.type) === 'data') {
    const locale = (loginData === null || loginData === void 0 ? void 0 : loginData.data.preferredLanguage) || navigator.language;
    return {
      langEnabled: true,
      locale
    };
  }
  return {
    langEnabled: true,
    locale: navigator.language
  };
}